module.exports = __webpack_public_path__ + "media/images/icons/country_flags/cu-e26b31c7aa254ee559008f1a9dd3b81b.svg";